import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiUsers, FiBox, FiDollarSign, FiHome, FiLogOut, FiTruck } from 'react-icons/fi';
import { authService } from '../../services/api';
import { toast } from 'react-toastify';

const AdminLayout = ({ children, setIsAuthenticated }) => {
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await authService.logout();
      setIsAuthenticated(false);
      toast.info('Session Terminated. Redirecting...');
    } catch (e) {
      toast.error('Logout failed');
    }
  };

  const menuItems = [
    { name: 'Dashboard', path: '/admin', icon: <FiHome /> },
    { name: 'Patients', path: '/admin/patients', icon: <FiUsers /> },
    { name: 'Inventory', path: '/admin/inventory', icon: <FiBox /> },
    { name: 'Payments', path: '/admin/payments', icon: <FiDollarSign /> },
    { name: 'Deliveries', path: '/admin/delivery', icon: <FiTruck /> },
  ];

  return (
    <div className="flex h-screen bg-[#f8fafc] font-poppins text-slate-900">
      {/* Sidebar */}
      <aside className="w-72 bg-white border-r border-slate-200 flex flex-col shadow-sm">
        <div className="p-8">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-10 h-10 bg-slate-900 rounded-xl flex items-center justify-center shadow-lg transition-transform group-hover:rotate-6">
              <span className="text-white font-bold text-xl">S</span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-black uppercase tracking-widest text-slate-900">Siyane</span>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-syana-blue-600">Optometrists</span>
            </div>
          </Link>
        </div>

        <nav className="flex-1 px-6 py-4 space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3.5 rounded-xl transition-all duration-300 ${
                  isActive 
                    ? 'bg-slate-900 text-white shadow-xl shadow-slate-200 translate-x-1' 
                    : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
                }`}
              >
                <span className={`text-lg ${isActive ? 'text-syana-blue-400' : ''}`}>{item.icon}</span>
                <span className="font-bold text-xs uppercase tracking-widest">{item.name}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-6 border-t border-slate-100">
          <button 
            onClick={handleLogout}
            className="w-full flex items-center space-x-3 px-4 py-3 text-slate-400 hover:text-red-500 transition-colors rounded-xl font-bold text-xs uppercase tracking-widest"
          >
            <FiLogOut className="text-lg" />
            <span>Logout System</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <header className="h-20 bg-white/80 backdrop-blur-md border-b border-slate-100 flex items-center justify-between px-10 sticky top-0 z-20">
          <div>
            <h2 className="text-xs font-black uppercase tracking-[0.3em] text-slate-400">Management System</h2>
            <h1 className="text-lg font-bold text-slate-900 capitalize mt-0.5">
              {location.pathname.split('/').pop() || 'Dashboard'}
            </h1>
          </div>
          <div className="flex items-center space-x-4">
             <div className="text-right">
                <p className="text-xs font-bold text-slate-900 leading-none">Syana Staff</p>
                <p className="text-[10px] text-slate-500 mt-1">Administrator</p>
             </div>
             <div className="w-10 h-10 bg-slate-100 rounded-full border-2 border-white shadow-sm overflow-hidden">
                <img src="https://ui-avatars.com/api/?name=Admin&background=0284c7&color=fff" alt="Avatar" />
             </div>
          </div>
        </header>

        <div className="p-8">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            {children}
          </motion.div>
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
